// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from "./store";
import VueResource from "vue-resource";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faUser, faShieldAlt, faSlidersH, faUserCog, faSms, faBars, faFileExcel, faPowerOff, faSpinner, faAngleLeft, faAngleRight, 
         faBirthdayCake, faPlusSquare, faCog, faFileAlt, faInfo, faMercury, faVenus, faMars, faSyncAlt} from "@fortawesome/free-solid-svg-icons";
import { faUser as farUser, faEdit as farEdit, faTrashAlt as farTrashAlt, faEye as farEye, faCheckSquare as farCheckSquare, faSquare as farSquare } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import SuiVue from 'semantic-ui-vue';

Vue.config.productionTip = false

Vue.use(VueResource);
Vue.use(SuiVue);

library.add( faUser, faShieldAlt, faSlidersH, faUserCog, faSms, faBars, faFileExcel, faPowerOff, faSpinner, faAngleLeft, faAngleRight, farEdit, farTrashAlt,
  faBirthdayCake, farEye, faPlusSquare, faCog, faFileAlt, farCheckSquare, farSquare, faInfo, faMercury, faVenus, faMars, faSyncAlt );
Vue.component('font-icon', FontAwesomeIcon)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js